<template>
  <TransitionPage>
    <router-view />
  </TransitionPage>
</template>

<script>
import TransitionPage from "@/components/TransitionPage";

export default {
  name: "pos-management",
  components: { TransitionPage }
};
</script>

<style scoped lang="scss"></style>
